module.exports = __webpack_public_path__ + "img/icon6.0f830b99.png";